//read apiurl from .env file
// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = "https://modern-burst-production.up.railway.app";

export {API_URL};
